import React from 'react';
import HiddenInput from 'shared/components/HiddenInput';

const ProductQuoteNumber = ({ parameters, groupName }) => {
  const name = 'product_quote_number';
  return (
    <HiddenInput
      name={name}
      value={parameters[name] || ''}
      groupName={groupName} />
  );
};

export default ProductQuoteNumber;
